import axiosClient from './axiosClient';
import { ActivityEvent } from '@/types/rfo';

export const activityApi = {
  getRecentActivity: async (limit: number = 20): Promise<ActivityEvent[]> => {
    const response = await axiosClient.get('/activity/recent', { params: { limit } });
    return response.data;
  },

  getOpportunityActivity: async (opportunityId: string, limit: number = 20): Promise<ActivityEvent[]> => {
    const response = await axiosClient.get(`/activity/opportunity/${opportunityId}`, { params: { limit } });
    return response.data;
  },
};
